export const researchPapers = [
    {
    id: 1,
    title: "Power Transformer Voltages Classification with Acoustic Signal in Various Noisy Environments",
    authors: "Mintai Kim, Sungju. Lee",
    journal: "MDPI Sensors",
    year: 2022,
    type: "SCI",
    doi: "https://doi.org/10.3390/s22031248"
  },
  {
    id: 2,
    title: "Augmenting Knowledge for Individual NVR Prediction in Different Spatial and Temporal Cross-Building Environments",
    authors: "Mintai Kim, Sungju. Lee",
    journal: "MDPI Electronics",
    year: 2024,
    type: "SCI",
    doi: "https://doi.org/10.3390/electronics13152901"
  },
  {
    id: 3,
    title: "Time Series Prediction Methodology and Ensemble Model Using Real-World Data",
    authors: "Mintai Kim, Sungju. Lee, Taikyeong Jeong",
    journal: "MDPI Electronics",
    year: 2023,
    type: "SCI",
    doi: "https://doi.org/10.3390/electronics12132811"
  },
  {
    id: 4,
    title: "Deep-Learning-Based Natural Ventilation Rate Prediction with Auxiliary Data in Mismeasurement Sensing Environments",
    authors: "Subhin Yang, Mintai Kim, Sungju Lee",
    journal: "MDPI Electronics",
    year: 2023,
    type: "SCI",
    doi: "https://doi.org/10.3390/electronics12153294"
  },
  {
    id: 5,
    title: "빠른 응답을 위한 규칙 기반 무인 커피 음성 주문 시스템AI",
    authors: "Su-Bhin Yang, Mintai Kim et al",
    journal: "Korean Institute of Information Scientists and Engineers",
    year: 2025,
    type: "KCI",
    link: "https://www.dbpia.co.kr/Journal/articleDetail?nodeId=NODE12152730"
  },
  {
    id: 6,
    title: "드라이브 스루 환경에서 규칙 기반 무인 커피 주문 시스템",
    authors: "Su-Bhin Yang, Mintai Kim et al",
    journal: "한국정보과학회 학술발표논문집, 제주.",
    year: 2024,
    type: "Conference",
    link: "https://www.dbpia.co.kr/Journal/articleDetail?nodeId=NODE11861831"
  },
  {
    id: 7,
    title: "질병 이력의 자연어 분석 기반 임상시험 참여 자격요건 판단",
    authors: "Nahyun Woo, Mintai Kim et al",
    journal: "한국통신학회 학술대회논문집",
    year: 2022,
    type: "Conference",
    link: "https://www.dbpia.co.kr/Journal/articleDetail?nodeId=NODE11108383"
  },
  {
    id: 8,
    title: "임상시험 참여의 적격성 판독을 위한 NLP 기반 전문가 시스템",
    authors: "Su-Bhin Yang, Mintai Kim et al",
    journal: "한국정보과학회 학술발표논문집, 제주.",
    year: 2022,
    type: "Conference",
    link: "https://www.dbpia.co.kr/Journal/articleDetail?nodeId=NODE11121486"
  },
  {
    id: 9,
    title: "준지도학습 기반 LDL-콜레스테롤 예측의 정확도 개선",
    authors: "Su-Bhin Yang, Mintai Kim et al",
    journal: "한국정보처리학회 학술대회논문집",
    year: 2022,
    type: "Conference",
    link: "https://kiss.kstudy.com/Detail/Ar?key=3957914"
  },
  {
    id: 10,
    title: "이상지질혈증 연관 인자를 활용한 얕은 학습 기반 HDL-콜레스테롤 예측",
    authors: "Su-bhin Yang, Mintai Kim et al",
    journal: "한국정보과학회 학술발표논문집",
    year: 2021,
    type: "Conference",
    link: "https://www.dbpia.co.kr/Journal/articleDetail?nodeId=NODE11036090"
  },
  {
    id: 11,
    title: "고지혈증 진단의 기계학습 정확도 개선을 위한 중요 임상데이터 특징 선택",
    authors: "Seonmin Lee, Mintai Kim et al",
    journal: "한국통신학회 학술대회논문집",
    year: 2021,
    type: "Conference",
    link: "https://www.dbpia.co.kr/Journal/articleDetail?nodeId=NODE10587556"
  },
  {
    id: 12,
    title: "U-net 기반 멜-스펙트로그램을 이용한 배전용 변압기의 배경 소리 제거",
    authors: "Mintai Kim, Seonmin Lee et al",
    journal: "한국정보과학회 학술발표논문집",
    year: 2021,
    type: "Conference",
    link: "https://www.dbpia.co.kr/Journal/articleDetail?nodeId=NODE10583482"
  },
  {
    id: 13,
    title: "소리 정보를 이용한 배전용 변압기의 이상 전압 탐지",
    authors: "Mintai Kim, Seonmin Lee et al",
    journal: "한국정보과학회 학술발표논문집",
    year: 2020,
    type: "Conference",
    link: "https://www.dbpia.co.kr/Journal/articleDetail?nodeId=NODE10529936"
  },
   {
    id: 14,
    title: "딥러닝 기반 의료 설문 결측 데이터 보간",
    authors: "Seonmin Lee, Donguk Kim, Taehyeon Lee, Mintae Kim et al",
    journal: "한국정보과학회 학술발표논문집",
    year: 2020,
    type: "Conference",
    link: "https://www.dbpia.co.kr/Journal/articleDetail?nodeId=NODE10530029"
  },
   {
    id: 15,
    title: "임베디드 환경에서 딥러닝 기반 디지털 헬스케어 시스템의 성능 비교 : Jetson TX2 NX와 Raspberry Pi 4",
    authors: "NaHyun Woo, GeonSoo Jang, YunJu Oh, Subhin Yang, Mintai Kim et al",
    journal: "한국정보과학회 학술발표논문집",
    year: 2023,
    type: "Conference",
    link: "https://www.dbpia.co.kr/Journal/articleDetail?nodeId=NODE11652270"
  },
{
  id: "thesis-01",
  type: "THESIS",
  title: "잡음에 강한 딥러닝 모델을 적용한 음향 신호를 이용한 변압기의 이상전압 상태 분류",
  authors: "Mintai Kim",
  year: "2024",
  journal: "Sangmyung University 석사 학위 논문",
  link: "https://dl.nanet.go.kr/search/searchInnerDetail.do?searchType=INNER_SEARCH&resultType=INNER_SEARCH_DETAIL&searchMehtod=L&searchClass=S&controlNo=KDMT12025000007089&queryText=%EC%83%81%EB%AA%85%EB%8C%80%ED%95%99%EA%B5%90%3APUB_WS%5EDP_PUB_WS%3AAND&prevQueryText=%EC%83%81%EB%AA%85%EB%8C%80%ED%95%99%EA%B5%90%3APUB_WS%5EDP_PUB_WS%3AAND&zone=PUB_WS%5EDP_PUB_WS&fieldText=&prevPubYearFieldText=&languageCode=&synonymYn=&refineSearchYn=N&ddcPopSearchYn=&pageNum=&pageSize=&orderBy=&topMainMenuCode=&topSubMenuCode=&totalSize=8962&totalSizeByMenu=8962&seqNo=&hanjaYn=Y&knowPub=&isdb=&isdbsvc=&tt1=&down=&frgnLangMtrlYn=N&targetLangCode=&checkedDbIdList=&baseDbId=&selectedDbIndexIdList=&caller=&asideState=&dpBranch=ALL&journalKind=&selZone=PUB_WS%5EDP_PUB_WS&searchQuery=%EC%83%81%EB%AA%85%EB%8C%80%ED%95%99%EA%B5%90"
},

];
